import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { ModalDialogComponent } from '@vg-constellation/angular-18/modal-dialog'
import { VideoComponent } from '@vg-constellation/angular-18/video'

import { AdvisorsComponent } from './components/advisor/advisor.component'
import { ConstellationVideoComponent } from './components/constellation-video/constellation-video.component'
import { DescriptionComponent } from './components/description/description.component'
import { FundManagementComponent } from './fund-management.component'

@NgModule({
  declarations: [
    FundManagementComponent,
    DescriptionComponent,
    AdvisorsComponent,
    ConstellationVideoComponent,
  ],
  imports: [CommonModule, VideoComponent, ModalDialogComponent],
  exports: [FundManagementComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FundManagementModule {}
